"use strict";
const htmlSanitize = require('sanitize-html');
const getSanitizeHtml = (html) => htmlSanitize(html, {
    allowedTags: false, // allows all tags
    allowedAttributes: false, // allows all attributes
    allowVulnerableTags: true, // if all tags are allowed, vulnerable tags are allowed too and warnings are not thrown
    transformTags: {
        '*': (tagName, attributes) => {
            const { onerror, onabort, onblur, onchange, ondblclick, onfocus, onkeydown, onkeyup, onload, onkeypress, onmousedown, onmouseenter, onmousemove, onmouseout, onmouseover, onmouseup, onreset, onresize, onselect, onsubmit, onunload, onanimationcancel, onanimationend, oncancel, oncanplay, oncanplaythrough, onclose, oncontextmenu, ondurationchange, onended, ongotpointercapture, oninput, oninvalid, onloadeddata, onloadedmetadata, onloadend, onloadstart, onlostpointercapture, onpointercancel, onpointerdown, onpointerenter, onpointerleave, onpointermove, onpointerout, onpointerover, onpointerup, onscroll, onwheel, ontransitioncancel, ontransitionend, ...attribs } = attributes;
            return { tagName, attribs };
        },
    },
    exclusiveFilter: (frame) => frame.tag === 'object' || frame.tag === 'script' || frame.tag === 'iframe',
});
module.exports = {
    getSanitizeHtml,
};
//# sourceMappingURL=html.js.map